import { ListSortBy } from '@core/models/common/list-sort-by';
import { IListState, initialListState } from '../shared/list/list.state';
import { ListSortDirection } from '@core/models/common/list-sort-direction';

export interface ILocationsState {
    companyLocations: IListState;
    viewedLocationId: string;
    locationRules: IListState;
}

export function initialLocationsState(): ILocationsState {
    return {
        companyLocations: {
            ...initialListState,
            sortBy: ListSortBy.NAME,
            sortDirection: ListSortDirection.ASCENDING
        },
        viewedLocationId: null,
        locationRules: {
            ...initialListState,
            sortBy: ListSortBy.NAME
        }
    };
};